import { ReactNode } from 'react';
import { Carousel as AntdCarousel } from 'antd';
import { ArrowLeftS, ArrowRightS } from '@styled-icons/remix-line';
import theme from 'styles/theme';

import * as S from './styles';

type CarouselProps = {
  children: ReactNode;
};

type ArrowProps = {
  className?: string;
  onClick?: () => void;
};

const Carousel = ({ children }: CarouselProps) => {
  const NextArrow = (props: ArrowProps) => (
    <button {...props} style={S.ArrowStyle}>
      <ArrowRightS color={theme.colors.neutralSilver60} size={18} />
    </button>
  );

  const PrevArrow = (props: ArrowProps) => (
    <button {...props} style={S.ArrowStyle}>
      <ArrowLeftS color={theme.colors.neutralSilver60} size={18} />
    </button>
  );

  return (
    <S.Wrapper>
      <AntdCarousel
        draggable
        arrows
        slidesToShow={2.3}
        infinite={false}
        swipeToSlide
        nextArrow={<NextArrow />}
        prevArrow={<PrevArrow />}
        dots={false}
        responsive={[
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1.5,
            },
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1.2,
            },
          },
        ]}
      >
        {children}
      </AntdCarousel>
    </S.Wrapper>
  );
};

export default Carousel;
